import { toPoint } from "mgrs";

export function mgrsToLatLon(mgrs: string): google.maps.LatLng {
  const point = toPoint(mgrs)
  return new google.maps.LatLng(point[1], point[0]);
}

export async function getSingleElevation(mgrs: string): Promise<number> {
  const center = mgrsToLatLon(mgrs);
  const elevation = new google.maps.ElevationService();

  const elevationRes = await elevation.getElevationForLocations(
    {
      locations: [center],
    }
  );
  if (elevationRes && elevationRes.results.length) {
    return elevationRes.results[0].elevation;
  }
  return 0;
}

export async function getElevation(mgrs: string, gridSize: number, cellSize = 1): Promise<{ elevations: number[], points: google.maps.LatLng[] }> {
  const center = mgrsToLatLon(mgrs);
  const cellHeightReference = google.maps.geometry.spherical.computeOffset(
    center,
    cellSize,
    0
  );
  const cellHeight = Math.abs(center.lat() - cellHeightReference.lat());

  const cellWidthReference = google.maps.geometry.spherical.computeOffset(
    center,
    cellSize,
    90
  );
  const cellWidth = Math.abs(center.lng() - cellWidthReference.lng());

  const offset = (gridSize - cellSize) / 2;

  const gridStart = google.maps.geometry.spherical.computeOffset(
    center,
    Math.hypot(offset, offset),
    225
  );

  const columnCount = Math.ceil(gridSize / cellSize);
  const rowCount = Math.ceil(gridSize / cellSize);

  const elevation = new google.maps.ElevationService();

  const points: google.maps.LatLng[] = [];
  for (let i = 0; i < rowCount; i++) {
    for (let j = 0; j < columnCount; j++) {
      const point = new google.maps.LatLng(
        gridStart.lat() + i * cellHeight,
        gridStart.lng() + j * cellWidth
      );
      points.push(point);
    }
  }
  console.log({ points });

  const elevations: number[] = [];
  for (let i = 0; i < points.length; i += 512) {
    const elevationRes = await elevation.getElevationForLocations(
      {
        locations: points.slice(i, i + 512),
      }
    );
    if (elevationRes && elevationRes.results.length) {
      elevations.push(...elevationRes.results.map((e) => e.elevation));
    }
  }

  // const remaining = points.length % 512;
  // if (remaining) {
  //   const elevationRes = await elevation.getElevationForLocations(
  //     {
  //       locations: points.slice(-remaining),
  //     }
  //   );
  //   if (elevationRes && elevationRes.results.length) {
  //     elevations.push(...elevationRes.results.map((e) => e.elevation));
  //   }
  // }
  console.log({ elevations });

  return { elevations, points };
}
